import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-days-of-week-component',
  templateUrl: './daysOfWeek.component.html',
  styleUrls: ['./daysOfWeek.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DaysOfWeekComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: (c: FormControl) => {
        const err = {
          noDaySelected: {
            content: 'No day selected',
          },
        };

        let numberOfSelected = 0;

        if (c.value) {

          for (const field of Object.keys(c.value)) {
            if (c.value[field]) {
              numberOfSelected += 1;
            }
          }
        }

        return !numberOfSelected ? err : null;
      },
      multi: true,
    },
  ],
})
export class DaysOfWeekComponent implements OnInit, ControlValueAccessor {
  @Input() formControl: FormControl;
  public days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  selects: FormGroup;

  private propagateChange = (_: any) => { };

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any) => { };

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value) {
    this.selects.setValue(value);
  }

  ngOnInit() {
    this.selects = new FormGroup({
      daily: new FormControl(),
      sunday: new FormControl(),
      monday: new FormControl(),
      tuesday: new FormControl(),
      wednesday: new FormControl(),
      thursday: new FormControl(),
      friday: new FormControl(),
      saturday: new FormControl(),
    });
  }

  onDayChecked() {
    let check: boolean;
    let numberOfChecked = 0;

    this.days.filter((day) => {
      if (this.selects.get(day).value) {
        numberOfChecked += 1;
      }
    });

    check = numberOfChecked === 7;

    this.selects.get('daily').setValue(check);
    this.propagateChange(this.selects.value);
    this.propagateTouch(this.selects.value);
  }

  checkAll() {
    let check: boolean;
    let numberOfChecked = 0;

    this.days.filter((day) => {
      if (this.selects.get(day).value) {
        numberOfChecked += 1;
      }
    });

    check = numberOfChecked !== 7;

    this.days.filter((day) => {
      this.selects.get(day).setValue(check);
    });

    this.selects.get('daily').setValue(check);
    this.propagateChange(this.selects.value);
    this.propagateTouch(this.selects.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/DaysOfWeekComponent/daysOfWeek.component.ts